import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import moment from 'moment';
import memoizeOne from 'memoize-one';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Info, Phone, Archive, Comment, Email, SdCard, Build } from '@material-ui/icons';
import { FHEContainer, FHEContainerScroll, FHETimeline } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { FormHistory } from '../forms';
import { getHomeHistory, addHomeHistory } from '../../../data/Homes/actions';
import getSelectors from '../selectors';

class History extends PureComponent {
    static propTypes = {
        getHomeHistory: PropTypes.func.isRequired,
        addHomeHistory: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        historyActions: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        isActive: PropTypes.bool
    };

    static defaultProps = {
        isActive: true
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: props.isActive,
            needGetData: props.isActive,
            fetching: false,
            onForm: false,
            historyInitialized: false,
            historyEvents: [],
            error: null
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { needGetData, loading, error, fetching, historyInitialized } = state;
        const { isActive } = props;

        if (!historyInitialized && isActive && !needGetData && !loading && !error && !fetching) return { needGetData: true, loading: true };
        return null;
    }

    componentDidMount() {
        const { isActive } = this.props;
        if (isActive) this.getHomeHistory();
    }

    componentDidUpdate(prevProps) {
        const { isActive } = this.props;
        const { needGetData, fetching, error, historyInitialized, onForm } = this.state;
        if (!historyInitialized && isActive && needGetData && !fetching && !error) {
            this.getHomeHistory();
        }
        if (isActive && !prevProps.isActive && onForm) {
            this.toggleOnForm();
        }
    }

    toggleOnForm = () => {
        const { onForm } = this.state;
        return this.setState({ onForm: !onForm });
    };

    formatHistoryEvents = memoizeOne((events, historyActions) => {
        let res = [];
        Object.keys(events)
            .sort((a, b) => {
                const fieldA = moment(a.dateEvent, 'DD/MM/YYYY hh:mm:ss');
                const fieldB = moment(b.dateEvent, 'DD/MM/YYYY hh:mm:ss');
                return fieldA.isAfter(fieldB) ? 1 : -1;
            })
            .map(eventId => {
                const event = events[eventId];
                const action = historyActions.getIn([event.actionId.toString()], false);

                res.push({
                    key: eventId,
                    date: moment(event.dateEvent, 'DD/MM/YYYY hh:mm:ss').format('DD/MM/YYYY hh:mm'),
                    supporUserName: event.supporUserName,
                    actionLabel: action ? action.get('label') : '',
                    content: event.comment,
                    position: action && action.get('direction') === 'entrant' ? 'right' : 'left',
                    icon: action && this.getActionIcon(action.get('icon'))
                });
            });
        return res;
    });

    getHomeHistory = () => {
        const { getHomeHistory, match, historyActions } = this.props;

        this.state.fetching = true;
        getHomeHistory(match.params.homeId, historyActions.size === 0)
            .then(events => {
                this.setState({
                    error: null,
                    loading: false,
                    fetching: false,
                    needGetData: false,
                    historyInitialized: true,
                    historyEvents: events
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false, needGetData: false, fetching: false });
            });
    };

    addHomeHistory = historyForm => {
        const { addHomeHistory, match } = this.props;

        return addHomeHistory(match.params.homeId, historyForm)
            .then(events => {
                this.setState({
                    historyEvents: events
                });
                return events;
            })
            .catch(err => {
                throw err;
            });
    };

    getActionIcon = sqlIcon => {
        const size = 'inherit';
        switch (sqlIcon) {
            case 'fa-archive':
                return <Archive fontSize={size} />;

            case 'fa-comments':
                return <Comment fontSize={size} />;

            case 'fa-envelope-o':
                return <Email fontSize={size} />;

            case 'fa-floppy-o':
                return <SdCard fontSize={size} />;

            case 'fa-phone':
                return <Phone fontSize={size} />;

            case 'fa-wrench':
                return <Build fontSize={size} />;
            default:
                return <Info fontSize={size} />;
        }
    };
    retryGetData = () => {
        this.setState({ error: null, loading: true, needGetData: true });
    };

    renderChildren = () => {
        const { historyEvents, onForm } = this.state;
        const { profile, historyActions, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        return (
            <Fragment>
                {(profile.get('admin') || userRights.includes(`homeAddHistory_${history.environment}`)) && (
                    <FormHistory addHomeHistory={this.addHomeHistory} toggleOnForm={this.toggleOnForm} onForm={onForm} />
                )}
                {!onForm && (
                    <FHEContainerScroll>
                        <FHETimeline events={this.formatHistoryEvents(historyEvents, historyActions)} />
                    </FHEContainerScroll>
                )}
            </Fragment>
        );
    };

    render() {
        const { error, loading } = this.state;

        return <FHEContainer hasNoClassContainer loading={loading} error={error} onClickFunc={this.retryGetData} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        historyActions: selectors.getHistoryActions(state),
        profile: selectors.getProfile(state)
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/sections/History',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getHomeHistory, addHomeHistory }), dispatch)
        )(History)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/sections/History.js